@if(isLoading()){
<search-loading-placeholder></search-loading-placeholder>
}@else{
<p [innerHtml]="text"></p>

<p class="app__form--attribute--title font-normal text-sm leading-6 text-[#18191C]">
  <span>
    {{ subText }}
  </span>
</p>
@if(currentType?.title == 'Suggestions'){
<mynetwork-suggestions [isFromNetworkSetup]="true" (moveToNextStepEmitter)="moveToNextStepEmitter.emit()"></mynetwork-suggestions>
}@else{
<app-connected-user-card
  style="height: 100%; max-height: 100%; display: block; margin-bottom: 24px; width: 99%"
  [isFromNetworkRequest]="true"
  [user]="currentUser"
  [relationshipType]="relationshipType"
  [networkRequestFilteredList]="filteredList"
  (handleConnectionsExistingEmitter)="handleConnectionsExisting($event)"
  (handleConnectCheckEmitter)="handleConnection($event)"
  (relationShipCountEmitter)="handleRelationShipCount($event)"
  (relationshipListEmitter)="handlerRelationshipList($event)"
  (allRelationshipListEmitter)="handlerAllRelationshipList($event)"
  [showCheckBox]="false"
></app-connected-user-card>
}}
